import { Box, CircularProgress, Theme } from '@mui/material';
import React from 'react';

type LoadingOverlayProps = {
  /** Show or hide the overlay */
  loading: boolean;
};

/**
 * A full‑screen, semi‑transparent overlay with a centered MUI CircularProgress.
 */
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <Box
      data-testid='loading-overlay'
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(0,0,0,0.3)',
        zIndex: 1400,
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)', // Safari
      }}
    >
      <CircularProgress
        size={80}
        thickness={2.8}
        sx={{ color: (theme: Theme) => theme.ragyaPalette.gray5 }}
      />
    </Box>
  );
};

export default LoadingOverlay;
